// extracted by mini-css-extract-plugin
export default {"catalogTitleContainer":"CatalogPage_catalogTitleContainer__t1TP+","catalogDescription":"CatalogPage_catalogDescription__il4Sn"};